/** Opens the account menu's Integrations drawer from anywhere — the Clerk
 *  account menu, and any "Sign in to Procore" prompt — without either one
 *  importing the shell that owns the drawer. */
export const OPEN_INTEGRATIONS_EVENT = "ledai:open-integrations";
export function openIntegrations() {
  window.dispatchEvent(new Event(OPEN_INTEGRATIONS_EVENT));
}
